module.exports = require("react-dimensions");


/*****************
 ** WEBPACK FOOTER
 ** external "react-dimensions"
 ** module id = 96
 ** module chunks = 0
 **/